import React, { useState, useEffect } from "react";
import { Card, CardBody, Col, Row, Label } from "reactstrap";
import "../sass/blogs.scss";
import TextSlicer from "../../components/TextSlicer";
import { useDispatch, useSelector } from "react-redux";
import { getAllBusinesses } from "../../slices/thunks";
import Loader from "../../components/Loader";
import MetaData from "../../components/MetaData";
import noPreview from "../../images/noPreview.jpg";

const description = `Explore Businesses Description`;

const Businesses = () => {
  const dispatch = useDispatch();

  const { businesses, isBusinessSuccess } = useSelector((state) => ({
    businesses: state.Business.businesses,
    isBusinessSuccess: state.Business.isBusinessSuccess,
  }));

  const [businessList, setBusinessList] = useState([]);

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const perPage = 10;

  useEffect(() => {
    loadBusinesses(1); // initial load
  }, []);

  const loadBusinesses = async (pageNumber) => {
    const res = await dispatch(
      getAllBusinesses({
        status: "approved",
        page: pageNumber,
        perPage,
        searchText: "",
      })
    );

    if (res?.payload?.items?.length) {
      if (pageNumber === 1) {
        setBusinessList(res.payload.items);
      } else {
        setBusinessList((prev) => [...prev, ...res.payload.items]);
      }

      // Check if fewer than perPage returned, means no more to load
      setHasMore(res.payload.items.length === perPage);
    } else {
      setHasMore(false); // no more data
    }
  };

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    loadBusinesses(nextPage);
  };

  const handleClick = (item) => {
    const url = `/business-detail/${item.slug}`;
    window.open(url, "_blank");
  };

  return (
    <>
      <MetaData metaTitle={"Businesses"} metaDescription={description} />
      {/* <AnimatePage> */}
      <div className="blog">
        <div className="page_body">
          <div className="container mt-5">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <div className="about_rgt_cont">
                  <h2 className="text-center">Explore Businesses</h2>

                  <TextSlicer text={description} />
                </div>
              </div>
            </div>

            {isBusinessSuccess ? (
              <>
                <Row
                  className="row-cols-xxl-4 row-cols-xl-3 row-cols-lg-2 row-cols-md-2 row-cols-1"
                  id="explorecard-list"
                >
                  {businessList &&
                    businessList?.map((item, key) => (
                      <Col className="list-element" key={key}>
                        <div
                          onClick={() => {
                            if (item?.status !== "Pending") {
                              handleClick(item);
                            }
                          }}
                          style={{
                            cursor: `${
                              item?.status === "Pending" ? "" : "pointer"
                            }`,
                          }}
                        >
                          <Card
                            className="explore-box card-animate"
                            style={{
                              filter: `${
                                item?.status === "Pending" ? "blur(5px)" : ""
                              }`,
                            }}
                          >
                            <div className="explore-place-bid-img">
                              <input
                                type="hidden"
                                className="form-control"
                                id="1"
                              />
                              <div className="d-none">undefined</div>
                              <img
                                src={item?.logo || noPreview}
                                alt=""
                                className="card-img-top explore-img"
                              />
                              <div className="bg-overlay"></div>
                            </div>

                            <CardBody>
                              <p className="mb-1">{item.business_name}</p>
                              <p className="text-muted mb-0">
                                {item?.business_category}
                              </p>
                            </CardBody>
                          </Card>
                        </div>
                      </Col>
                    ))}
                </Row>
              </>
            ) : (
              <Loader />
            )}

            <div
              className="py-4 text-center"
              id="noresult"
              style={{ display: "none" }}
            >
              <lord-icon
                src="https://cdn.lordicon.com/msoeawqm.json"
                trigger="loop"
                colors="primary:#405189,secondary:#0ab39c"
                style={{ width: "72px", height: "72px" }}
              ></lord-icon>
              <h5 className="mt-4">Sorry! No Result Found</h5>
            </div>
            {hasMore && (
              <div className="text-center mb-3">
                <button
                  className="btn btn-link text-success mt-2"
                  onClick={handleLoadMore}
                >
                  Load More
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* </AnimatePage> */}
    </>
  );
};

export default Businesses;
